const InfoCards = () => {
  return (
    <section className="relative -mt-10 z-20 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-4">

          <div className="bg-[#1A1A18]/80 backdrop-blur-md border border-[#FDFCF8]/10 rounded-2xl p-6 text-center">
            <div className="text-3xl mb-2">☀️</div>
            <h3 className="font-syne text-lg font-bold text-white mb-1">
              Öppettider
            </h3>
            <p className="text-white/70 font-dm">
              Mån, Ons, Tors, Fre, Lör & Sön
            </p>
            <p className="text-[#FFA500] font-syne text-2xl font-bold mt-2">
              11–01
            </p>
          </div>

          <div className="bg-[#1A1A18]/80 backdrop-blur-md border border-[#FDFCF8]/10 rounded-2xl p-6 text-center">
            <div className="text-3xl mb-2">📩</div>
            <h3 className="font-syne text-lg font-bold text-white mb-1">
              Cityfestivalen
            </h3>
            <p className="text-white/70 font-dm">
              Bordsbokning sker endast via
            </p>
            <p className="text-[#FF66A3] font-bold mt-2">
              Mail eller DM
            </p>
          </div>

          <div className="bg-[#1A1A18]/80 backdrop-blur-md border border-[#FDFCF8]/10 rounded-2xl p-6 text-center">
            <div className="text-3xl mb-2">🌧️</div>
            <h3 className="font-syne text-lg font-bold text-white mb-1">
              Väderinfo
            </h3>
            <p className="text-white/70 font-dm">
              Vid kraftigt regn kan verksamheten hålla stängt.
            </p>
            <p className="text-[#32CD32] font-bold mt-2">
              Följ oss på Instagram
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default InfoCards;
